import {toNumericTreeNodeId} from 'src/app/tree-browser/treeBrowserUtils';

export const assetTreeRootId = 'all';

/** `TreeResponse.kind` values the asset tree endpoint emits. */
export const assetTreeKinds = {group: 'group', asset: 'asset'} as const;

/** Tree node id for an asset group id; the root id for missing, zero or invalid ids. */
export const toAssetTreeNodeId = (nodeId?: string | number | null): string =>
  toNumericTreeNodeId(nodeId, assetTreeRootId);

export const toAssetListFilter = (nodeId?: string): {parentId?: number} => {
  if (!nodeId || nodeId === assetTreeRootId) return {};

  const parentId = Number(nodeId);
  return Number.isSafeInteger(parentId) && parentId > 0 ? {parentId} : {};
};
